import { TProjectEditorState } from 'shared/reducers';

export const selectProjectId = (state: TProjectEditorState) => {
  return state.id;
};
